import { useCallback } from "react"
import useApi from "./api"
import { useConsentValidator } from "./ConfigValidation"


export default function useIniciador() {
    const { sendRequest } = useApi()
    const validateConsentId = useConsentValidator()

    const iniciar = useCallback(async (cpf, cnpj, token, company, consentId) => {
        let path
        let consent = ""
        if (validateConsentId(consentId)) {
            consent = consentId ? `&consentId=${consentId}` : ''
        }

        if (cnpj) {
            path = `/iniciador/cnpj/${cnpj}/cpf/${cpf}?token=${token}&company=${company}${consent}`
        } else {
            path = `/iniciador/cpf/${cpf}?token=${token}&company=${company}${consent}`
        }
        const result = await sendRequest(path)
        return result

    }, [sendRequest, validateConsentId])

    return { iniciar }
}